import React from 'react';
import { settings, getLanguageObj } from '../../helpers/UtilsHelper';
import { GlobalFormats } from '../../classes/main/globalFormatClass';

const { app, company, icons, labels } = settings;

const currentMethod = 'Footer - function';

export default function Footer({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    return (
        <footer className='main-footer border-top-0 bg-white text-muted text-center py-3 shadow-sm'>
            <div className='container-fluid'>
                <div className='row align-items-center'>
                    <div className='col-12 col-md-6 text-md-left mb-2 mb-md-0'>
                        <strong>Copyright &copy; {app?.copyRight} - <a href={company?.url} target='_blank' rel='noreferrer' className='link-primary-bold'>{company.name}</a></strong>
                        {' '}<span className='d-none d-sm-inline-block'>{labels?.allRightsReserved?.[languageObj?.id]}</span>
                    </div>
                    <div className='col-12 col-md-6 text-md-right'>
                        <span className='badge badge-light p-2 badge-version'>
                            <i className={`${icons?.fasFa?.codeBranch} mr-1`} /> {labels?.version?.[languageObj?.id]} {app?.version}
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
}